export default __webpack_public_path__ + "static/media/resume.431c941f.pdf";